import * as Sentry from '@sentry/browser'

import { agentV2Request } from '@/agent-v2/conversations/fetch/agent-v2-request'
import { kAgentV2MatterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { MatterWhereYouLeftOffResponse, MatterWhereYouLeftOffResponseSchema } from '@/matter/where-you-left-off/schemas'
import { getResponseDebugContext, getTopLevelKeys } from '@/util/api/response-body'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'

export async function getMatterWhereYouLeftOff(matterId: string, signal?: AbortSignal): Promise<MatterWhereYouLeftOffResponse> {
  const url = `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2MatterApiBasePath}${matterId}/where-you-left-off`
  return agentV2Request({
    url,
    method: 'GET',
    signal,
    sentryEndpoint: 'GET /api/v2/matter/{matter_id}/where-you-left-off',
    sentryExtra: { matterId },
    parseResponse: (data, { response, sentryTags }) => {
      const parsed = MatterWhereYouLeftOffResponseSchema.safeParse(data)
      if (parsed.success) return parsed.data

      Sentry.withScope((scope) => {
        scope.setTags(sentryTags)
        Sentry.captureException(new Error('Matter where-you-left-off response schema validation failed'), {
          extra: {
            ...getResponseDebugContext(response, url),
            matterId,
            responseKeys: getTopLevelKeys(data),
            issues: parsed.error.issues,
          },
        })
      })
      throw new ApiResponsePayloadError(response.status, 'Invalid Matter where-you-left-off response shape', parsed.error.issues)
    },
  })
}
